// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"54":"p__reports__print","941":"p__games__play"}[chunkId] + ".chunk.css";
};